import React from 'react';
import { useSelector } from 'react-redux';
import isEmpty from 'lodash/fp/isEmpty';
import { ProductCategoryService } from 'services';
import { Section, FunTag } from 'components/shared';
import { FunTagListPropsWithState } from './FunTagList.types';
import { selectCurrentProduct } from 'store/currentProduct';
import styles from './FunTagList.module.scss';

const FunTagList: React.FC<FunTagListPropsWithState> = ({ title = '' }) => {
  const { product } = useSelector(selectCurrentProduct);

  const list = product?.fun_tags;

  if (isEmpty(list)) {
    return null;
  }

  const renderFunTagList =
    list?.length &&
    list.map((item, index) => (
      <li key={`${index}-${item}`} className={styles.list__item}>
        <FunTag
          text={item}
          link={ProductCategoryService.getUrlToCategoryFilter('tags', item)}
        />
      </li>
    ));

  return (
    <div className={styles.wrapper}>
      <Section title={title}>
        <ul className={styles.list}>{renderFunTagList}</ul>
      </Section>
    </div>
  );
};

export default FunTagList;
